import createPersistedState from 'vuex-persistedstate';

export default ({ store }) => {
  createPersistedState({
    storage: window.sessionStorage,
    paths: ['shipping-method', 'checkout', 'basket']
  })(store);
};
